import script from "./ItemMenu.vue?vue&type=script&setup=true&lang=ts"
export * from "./ItemMenu.vue?vue&type=script&setup=true&lang=ts"

import "./ItemMenu.vue?vue&type=style&index=0&id=25d06172&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-25d06172"]])

export default __exports__